import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-from-right-icon',
  templateUrl: './navigation-arrow-from-right.component.html'
})
export class NavigationArrowFromRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
